import type { SpaceProps, SpaceValue } from './Space.typed';
import * as Styled from './Space.styled';
import { SpacingValue } from 'styled-system';

const getSpaceBreakpoints = (
  xs?: SpacingValue,
  sm?: SpacingValue,
  md?: SpacingValue,
  lg: SpacingValue = 'S2',
) => ({
  xs: xs || sm || md || lg,
  sm: sm || md || lg,
  md: md || lg,
  lg: lg,
});

export const Space = (props: SpaceProps) => {
  const { space, inline = false, ...rest } = props;

  const spaceProp: SpaceValue =
    typeof space === 'string'
      ? space
      : {
          ...getSpaceBreakpoints(space?.xs, space?.sm, space?.md, space?.lg),
        };

  return <Styled.Space inline={inline} space={spaceProp} {...rest} />;
};

export default Space;
